var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("symbol", {
    id: "logo-org",
    viewBox: "0 0 900 900"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0652174949645996, 0, 0, 1.0652174949645996, -36.000030517578125, -34.75414276123047)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.268953561782837, 0, 0, 1.268953561782837, -200.79175567626953, -28.598134994506836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 513.940002 151.410004 H 529.940002 V 401.410004 H 513.940002 V 151.410004 Z",
    fill: "currentColor",
    opacity: 0.3,
    transform: "matrix(1, 0, 0, 1, 0, 244.29577697253893)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 538.940002 374.410004 H 764.940002 V 394.410004 H 538.940002 V 374.410004 Z",
    fill: "currentColor",
    transform: "matrix(0.7355187535285949, -0.6775110363960265, 0.6775110363960265, 0.7355187535285949, -127.78391117691785, 458.52149567413767)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 446.690002 399.570007 H 607.210007 V 419.570007 H 446.690002 V 399.570007 Z",
    transform: "translate(169.1 -261.59) rotate(27.64)",
    fill: "currentColor",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 551.940002 384.410004 A 30 30 0 0 1 521.940002 414.410004 A 30 30 0 0 1 491.940002 384.410004 A 30 30 0 0 1 521.940002 354.410004 A 30 30 0 0 1 551.940002 384.410004 Z",
    fill: "currentColor",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.973057270050048, 0, 0, 7.973057270050048, -4760.378906249999, -6170.363769531249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-1",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M654,884c-29.2,0-53-23.8-53-53s23.8-53,53-53s53,23.8,53,53S683.2,884,654,884z M654,784 c-25.9,0-47,21.1-47,47s21.1,47,47,47s47-21.1,47-47S679.9,784,654,784z",
    style: {
      fill: "currentColor"
    }
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    viewBox: "0 0 980 980",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 490,
    r: 320,
    style: {
      fill: "#ff5860",
      fillOpacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9570314288139343, 0, 0, 0.9570314288139343, -14.862064361572266, 70.53074169158936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.650505 503.844202c16.872727 17.215354 16.585697 44.859475-0.610263 61.732202-17.233455 16.890828-44.877576 16.606384-61.74901-0.610263l-192.969697-196.936404c-16.872727-17.212768-16.585697-44.856889 0.610263-61.732202 17.233455-16.892121 44.877576-16.602505 61.750303 0.610263l192.968404 196.936404z",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0.51
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.168074131011963, 0, 0, 3.168074131011963, -1269.8590774536133, -1367.2354736328125)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5.684341886080802e-14, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M550.5,476.1c0,0-67.8-14.7-113.1,57.7s32.4,149.7,153.8,145.5c121.4-4.1,111.9-126.7,41.2-160.3 c0,0,99,30.6,57.7,120.2C648.9,728.9,489.8,720,435,644C380.2,568,425.6,442,550.5,476.1z",
    style: {
      fill: "#ff5860",
      fillOpacity: 0.5
    },
    transform: "matrix(1, 0, 0, 1, 1.8758328224066645e-12, 4.547473508864641e-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3952163867585334, 0, 0, 1.3952163867585334, -285.46136037324766, -303.389817134351)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5.684341886080802e-14, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M601.1,457.9c1.5-25.4-10-27.7-11.2-11.8c-1.2,15.9,1.2,44.8-0.6,50.1C587.6,501.5,598.8,498.5,601.1,457.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(1.7707531452178955, 2.3391940593719482, -2.3391940593719482, 1.7707531452178955, 658.9467104745598, -1611.7817456848925)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.79ecbdd4c760464e6c906bdbf3617252.svg";
export { ForwardRef as ReactComponent };